import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SharedModule } from 'src/shared/shared.module';

import { CardIconBlockComponent } from 'src/pages/properties/components/shared/card-icon-block/card-icon-block.component';
import { getHappinessIconSrc } from 'src/pages/marketing/components/shared/happiness-visuals.util';
import { DemoBlockService } from 'src/shared/services/demo-block.service';

import { HappinessItem } from 'src/models/happiness-item.model';

export type HappinessFlag = 'can_upsell' | 'can_comp';

@Component({
  selector: 'tidy-happiness-card',
  templateUrl: './happiness-card.component.html',
  styleUrls: ['./happiness-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IonicModule, TidyUiComponentsModule, SharedModule, CardIconBlockComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HappinessCardComponent {
  private readonly demoBlock = inject(DemoBlockService);

  @Input() item!: HappinessItem;
  /**
   * Renders the same card frame with grey placeholders (icon tile, name
   * line, flag rows) instead of item data. The real card then replaces it
   * in place instantly, so the swap reads as the skeleton becoming the card.
   */
  @Input() skeleton = false;
  @Output() edit = new EventEmitter<HappinessItem>();
  @Output() flagChange = new EventEmitter<{ item: HappinessItem; flag: HappinessFlag; value: boolean }>();

  get iconSrc(): string {
    return getHappinessIconSrc(this.item);
  }

  onCardClick() {
    if (this.demoBlock.block()) { return; }
    this.edit.emit(this.item);
  }

  onUpsellChange(value: boolean) {
    if (this.demoBlock.block()) { return; }
    this.flagChange.emit({ item: this.item, flag: 'can_upsell', value });
  }

  onCompChange(value: boolean) {
    if (this.demoBlock.block()) { return; }
    this.flagChange.emit({ item: this.item, flag: 'can_comp', value });
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
